import { AppDispatch } from "..";
import { UserProfileDto } from "../../interfaces";
import { setProfile } from "../slices/accountSlice";
import { baseApi } from "./baseApi";

export const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query<UserProfileDto, void>({
      query: () => ({
        url: `/api/user/profile/me`,
      }),
      async onQueryStarted(
        _: void,
        {
          dispatch,
          queryFulfilled,
        }: {
          dispatch: AppDispatch;
          queryFulfilled: Promise<{ data: UserProfileDto }>;
        },
      ) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setProfile(data));
        } catch (error) {
          console.log(error);
          dispatch(setProfile(null));
        }
      },
      providesTags: ["Account"],
    }),
    updateUserProfile: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/profile/me",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Account"],
    }),
    changePassword: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/profile/change-password",
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useChangePasswordMutation,
} = accountApi;
